<div matDialogTitle>Impressum</div>

<mat-divider />

<mat-dialog-content>
  <div style="font-size: small" class="text">
    <p>
      Medieninhaber, Herausgeber, Redaktion, Gestaltung der Website:<br />
      <b>Merkur Versicherung Aktiengesellschaft, Conrad-von-Hötzendorf-Straße 84, 8010 Graz</b>
    </p>

    <div style="margin-top: 10px">
      <div class="out">
        <div>Telefon:</div>
        <div class="text-accent">
          <a href="tel:004331680340">0043-316/8034-0</a>
        </div>
      </div>

      <div class="out">
        <div>E-Mail:</div>
        <a href="mailto:merkur@merkur.at">merkur&#64;merkur.at</a>
      </div>

      <div class="out">
        <div>Internet:</div>
        <a href="http://www.merkur.at" target="_blank">http://www.merkur.at</a>
      </div>

      <div class="out">
        <div>Gesellschaftsform:</div>
        <div class="text-accent">Aktiengesellschaft mit Sitz in Graz</div>
      </div>

      <div class="out">
        <div>Firmenbuchnummer:</div>
        <div class="text-accent">38045z</div>
      </div>

      <div class="out">
        <div>Firmenbuchgericht:</div>
        <div class="text-accent">Landesgericht für ZRS Graz DVR: 0047465</div>
      </div>

      <div class="out">
        <div>UID:</div>
        <div class="text-accent">ATU28646007</div>
      </div>

      <div class="out">
        <div>Aufsichtsbehörde:</div>
        <div class="text-accent">Finanzmarkt Aufsichtsbehörde, Otto-Wagner-Platz 5, 1090 Wien</div>
      </div>
    </div>

    <div style="margin-top: 30px; font-size: x-small; text-align: justify">
      <p>
        Die Merkur Versicherung Aktiengesellschaft ist Mitglied der Wirtschaftskammer Österreich, der Wirtschaftskammer
        Graz und des Verbandes der Versicherungsunternehmen Österreichs.
      </p>

      <p>
        Unternehmensgegenstand des Medieninhabers: Die Gesellschaft betreibt direkt und indirekt die Kranken-, Lebens-
        und Unfallversicherung sowie die Schadenversicherung in den von der Versicherungsaufsichtsbehörde laut
        Geschäftsplan genehmigten Zweigen.
      </p>

      <p>
        Die Gesellschaft kann in Erfüllung ihres Zweckes mit Krankenanstalten und Erholungsheimen Vereinbarungen über
        die Betreuung der Versicherungsnehmer treffen und sich an Krankenanstalten und Erholungsheimen beteiligen.
      </p>
    </div>
  </div>
  <mat-divider />
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" mat-dialog-close>OK</button>
</mat-dialog-actions>
